import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2b70c68a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "foot"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.footer ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["footer", $props.linkOpen && $props.linkOpen == 1 ? '' : 'top-read'])
  }, [_createElementVNode("div", _hoisted_1, _toDisplayString($data.footer), 1)], 2)) : _createCommentVNode("", true);
}